// ---------------------------------------------------------------------
// FancyGlide
// ---------------------------------------------------------------------

/* animates the move to an anchor link */
/* xxx - should have a way to turn this behavior off (rel="noglide") */
function setupGlide() {
    Foundation.documentReady.then(function () {
        $$("a[href^=#]").each(function(thelink) {
            var linkedElement = $(thelink.readAttribute('href').split('#')[1]);
            if (linkedElement && !thelink.readAttribute('onclick')) {
                thelink.observe("click", function(e) {
                    e.stop();
                    new Effect.ScrollTo(linkedElement);
                });
            }
        });
    });
}


// ---------------------------------------------------------------------

window["setupGlide"] = setupGlide;

// ---------------------------------------------------------------------

